import SelectDoorAndStovePostitionComponent from '../components/SelectDoorAndStovePostitionComponent';
import { stovePositionUpdated, saunaCadImageUpdated} from '../actions';
import { doorFromLeftUpdated, changeDoorHandness } from '../actions/door.js'
import { connect } from 'react-redux'
import { stoves } from '../config';
import { convertCoordinatesToWallBasedPositioning } from '../helpers/stovePositionConverter';

const mapStateToProps = (state, ownProps) => {
    let selectedStove = stoves.find(s => state.benchModel.stove === s.id);
    let stoveImage = selectedStove.cadImage || "img/stoves/default.png";
    let stovePosition = convertCoordinatesToWallBasedPositioning(state.measurements);
    let stoveRotation = 0;
    switch (stovePosition.stoveWall) {
        case "right":
            stoveRotation = -90;
            break;
        case "left":
            stoveRotation = 90;
            break;
        case "back":
            stoveRotation = 180;
            break;
        default:
            stoveRotation = 0;
            break;
    }
    return {
        measurements: state.measurements,
        lockDoorPosition: (state.clientConfiguration) ? !state.clientConfiguration.canMoveDoor : false,
        lockStovePosition: (state.clientConfiguration) ? !state.clientConfiguration.canMoveStove : false,
        benchImage: state.benchModel.cadImage,
        stoveImage: stoveImage,
        stoveRotation: stoveRotation,
        cadImageUpdatePending: state.measurements.cadImageUpdatePending,
        drawStove:state.plan.hasBench,
        drawBench:state.plan.hasBench
    };
}
const mapDispatchToProps = (dispatch, ownProps) => ({ 
    doorFromLeftUpdated:(e)=>{
       dispatch(doorFromLeftUpdated(e));   
    },
    stovePositionUpdated:(pos)=>{
      dispatch(stovePositionUpdated(pos));
    },
    saunaCadImageUpdated: (image)=>
    {
        dispatch(saunaCadImageUpdated(image));
    },
    doorHandnessChanged: () => {
        dispatch(changeDoorHandness());
    }

  });

const SelectDoorAndStovePostitionContainer = connect(mapStateToProps,mapDispatchToProps,null,{withRef:true})(SelectDoorAndStovePostitionComponent)

export default SelectDoorAndStovePostitionContainer;

